import script from "./EmailForgot.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailForgot.vue?vue&type=script&setup=true&lang=js"

import "./EmailForgot.vue?vue&type=style&index=0&id=0253a5ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0253a5ab"]])

export default __exports__